const label = (h) => `${h % 12 || 12}${h < 12 ? 'a' : 'p'}`;

// 24 slim bars (Eastern Time hours); best hour highlighted.
export function HourBars({ title, values, hint, suffix = '', testId, eligible = () => true }) {
  const max = Math.max(...values, 0);
  const top = Math.max(0, ...values.filter((v, h) => eligible(h)));
  const best = top > 0 ? values.findIndex((v, h) => v === top && eligible(h)) : -1;
  return (
    <div data-testid={testId}>
      <div className="flex items-baseline justify-between mb-1">
        <p className="text-[#FF9F0A] uppercase text-[11px]">{title}</p>
        <p className="text-[10px] text-[#39FF14]" data-testid={`${testId}-best`}>{best >= 0 ? `Best: ${label(best)}m · ${top}${suffix}` : 'Not enough data yet'}</p>
      </div>
      <div className="flex items-end gap-[2px] h-16 border-b border-[#2A0F3D]">
        {values.map((v, h) => (
          <div key={h} title={`${label(h)}m · ${hint(h)}`} className="flex-1 h-full flex items-end" data-testid={`${testId}-bar-${h}`}>
            <div className={`w-full ${h === best ? 'bg-[#39FF14]' : eligible(h) ? 'bg-[#FF9F0A]/60' : 'bg-[#6B8E73]/40'}`} style={{ height: max ? `${Math.max(v ? 6 : 0, (v / max) * 100)}%` : 0 }} />
          </div>
        ))}
      </div>
      <div className="flex text-[9px] text-[#6B8E73] mt-0.5">
        {values.map((_, h) => <span key={h} className="flex-1 text-center">{h % 6 === 0 ? label(h) : ''}</span>)}
      </div>
    </div>
  );
}
